import Products from '@Generator/create/Products';
import Releases from './Releases';
import Prompt from './Prompt';
import Preview from './Preview';
import PromptSelect from '@Components/analyzer/controls/PromptSelect';
import { useAuth } from '@Context/CognitoAuthProvider';
import { promptToolboxAPI } from '@Lib/axios/prompt-toolbox';
import { useEffect, useState } from 'react';
import { AhaTicketGeneratorPrompt } from '@Models/types';
import ViewPromptModal from '@Components/analyzer/views/modals/ViewPromptModal';
import AddPromptModal from '@Components/analyzer/views/modals/AddPromptModal';

const AhaTicket = () => {
  const [promptOptions, setPromptOptions] = useState<
    AhaTicketGeneratorPrompt[]
  >([]);
  const [selectedBasePrompt, setSelectedBasePrompt] =
    useState<AhaTicketGeneratorPrompt | null>(null);
  const [showViewPrompt, setShowViewPrompt] = useState<boolean>(false);
  const [showAddPrompt, setShowAddPrompt] = useState<boolean>(false);
  const { logout } = useAuth();
  const promptToolbox = promptToolboxAPI(logout);

  useEffect(() => {
    const fetchAhaTicketGeneratorPrompts = async () => {
      try {
        const prompts = await promptToolbox.getAhaTicketGeneratorPrompts();
        if (prompts.length > 0) {
          setPromptOptions((prev) => [...prev, ...prompts]);
        }
      } catch (error) {
        console.error('Error fetching Aha! Ticket Generator Prompts: ', error);
      }
    };

    fetchAhaTicketGeneratorPrompts();
  }, []);

  return (
    <div className="flex h-full">
      <ViewPromptModal
        isOpen={showViewPrompt}
        onCancel={() => setShowViewPrompt(false)}
        prompt={selectedBasePrompt}
        type="generator prompt"
        onPromptEdited={setPromptOptions}
      />
      <AddPromptModal
        isOpen={showAddPrompt}
        onCancel={() => setShowAddPrompt(false)}
        onPromptAdded={setPromptOptions}
        type="generator prompt"
      />
      <div className="flex w-full flex-col gap-2 lg:flex-row">
        {/* BOX 1 */}
        <div className="flex h-full w-full flex-col gap-2 lg:w-3/5">
          <div className="flex w-full flex-col gap-2 sm:flex-row">
            <div className="sm:w-1/2">
              <Products />
            </div>
            <div className="sm:w-1/2">
              <Releases />
            </div>
          </div>
          <div className="flex space-x-5 rounded-lg bg-white p-4">
            <PromptSelect<AhaTicketGeneratorPrompt>
              type="generator prompt"
              onShowView={() => setShowViewPrompt(true)}
              onShowPrompt={() => setShowAddPrompt(true)}
              value={
                selectedBasePrompt
                  ? {
                      label: selectedBasePrompt.name,
                      value: selectedBasePrompt,
                    }
                  : null
              }
              options={promptOptions.map((prompt) => ({
                label: prompt.name,
                value: prompt,
              }))}
              placeholder={'Set Base Prompt'}
              onChange={(option) =>
                setSelectedBasePrompt(option ? option.value : null)
              }
              onPromptsUpdated={setPromptOptions}
            />
          </div>
          <Prompt basePrompt={selectedBasePrompt} />
        </div>

        {/* BOX 2 */}
        <div className="flex h-full w-full lg:w-2/5">
          <Preview />
        </div>
      </div>
    </div>
  );
};

export default AhaTicket;
